import React, { FC, HTMLProps, ReactNode } from "react";
import cn from "classnames";
import stl from "./index.module.scss";

interface Props extends HTMLProps<HTMLDivElement> {
  variant?: "default" | "primary" | "secondary" | "primaryFilled";
  icon?: ReactNode;
  iconPos?: "before" | "after";
}

const Tag: FC<Props> = ({
  className,
  variant = "default",
  icon,
  iconPos = "before",
  ...props
}) => {
  const actualProps = { className: cn(className, stl.block), ...props };

  if (variant) {
    let variantClassName = "";

    switch (variant) {
      case "default": {
        variantClassName = stl.default;
        break;
      }
      case "primary": {
        variantClassName = stl.primary;
        break;
      }
      case "secondary": {
        variantClassName = stl.secondary;
        break;
      }
      case "primaryFilled": {
        variantClassName = stl.primaryFilled;
        break;
      }
    }

    actualProps.className = cn(actualProps.className, variantClassName);
  }

  if (icon) {
    actualProps.children =
      iconPos === "before" ? (
        <>
          <span className={stl.iconWrap}>{icon}</span>
          {props.children}
        </>
      ) : (
        <>
          {props.children}
          <span className={stl.iconWrap}>{icon}</span>
        </>
      );

    actualProps.className = cn(
      actualProps.className,
      iconPos === "before" ? stl.iconBefore : stl.iconAfter
    );
  }

  return React.createElement("div", actualProps);
};

export default Tag;
